import { getBuildingSidePadding, getBuildingSidePlacement } from './building-layout.utils.js';

const initializedContainers = new WeakSet();

const initImpactBuilding = (scope = document) => {
  const containers = scope.matches?.('.impact-building-container')
    ? [scope]
    : scope.querySelectorAll('.impact-building-container');

  containers.forEach((container) => {
    if (initializedContainers.has(container)) {
      return;
    }

    const bg = container.querySelector('.impact-building-container__bg');
    const buildingSection = container.querySelector('.building-sec');
    const buildingTitle = buildingSection?.querySelector('.building-sec__title');
    const buildingSubtitle = buildingSection?.querySelector('.building-sec__subtitle');
    const buildingSide = buildingSection?.querySelector('.building-sec__side');
    const buildingAside = buildingSection?.querySelector('.building-sec__aside');

    if (!bg || !buildingSection) {
      return;
    }

    initializedContainers.add(container);

    let resizeFrame = null;

    const moveAsideForLayout = () => {
      if (!buildingSubtitle || !buildingSide || !buildingAside) {
        return;
      }

      if (getBuildingSidePlacement(window.innerWidth) === 'content') {
        buildingSubtitle.insertAdjacentElement('afterend', buildingAside);
        return;
      }

      buildingSide.prepend(buildingAside);
    };

    const updateSidePadding = () => {
      if (!buildingTitle || !buildingSide) {
        return;
      }

      const titleHeight = buildingTitle.getBoundingClientRect().height;
      const titleMarginBottom = Number.parseFloat(window.getComputedStyle(buildingTitle).marginBottom) || 0;
      const padding = getBuildingSidePadding(window.innerWidth, titleHeight, titleMarginBottom);

      if (padding === 0) {
        buildingSide.style.removeProperty('--building-sec-side-padding');
        return;
      }

      buildingSide.style.setProperty('--building-sec-side-padding', `${padding}px`);
    };

    const updateBgOffset = () => {
      const containerTop = container.getBoundingClientRect().top;
      const buildingTop = buildingSection.getBoundingClientRect().top;
      const offset = Math.max(0, buildingTop - containerTop);

      bg.style.setProperty('--building-sec-top-offset', `${offset}px`);
      bg.style.opacity = '1';
      moveAsideForLayout();
      updateSidePadding();
    };

    const throttledUpdateBgOffset = () => {
      if (resizeFrame) {
        return;
      }

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;
        updateBgOffset();
      });
    };

    throttledUpdateBgOffset();
    window.setTimeout(throttledUpdateBgOffset, 200);
    window.setTimeout(throttledUpdateBgOffset, 1000);
    window.addEventListener('resize', throttledUpdateBgOffset, { passive: true });
  });
};

initImpactBuilding();
window.initImpactBuilding = initImpactBuilding;
